import { M as Qo } from "./mapMarker-3af5c1ff.js";
import "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./export-cdcbfb2b.js";
import "./es.array.concat-d1c9b847.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./array-iteration-759bfbfa.js";
import "./es.object.to-string-f55666a8.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./focusTrap.js";
import "./es.array.filter-4e9c9996.js";
import "./es.array.find-index-cbf7640b.js";
import "./es.array.from-fe752fa6.js";
import "./iterate-13ada9e5.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./es.array.index-of-084b82ab.js";
import "./array-method-is-strict-e5a3c878.js";
import "./es.array.some-0c761b6d.js";
import "./es.object.assign-7e79fd7b.js";
import "./es.string.iterator-5de8a61e.js";
import "./es.string.replace-f4cc3aea.js";
import "./function-apply-4756dee6.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./index-8b07dec9.js";
import "react";
import "./es.object.keys-9d66766f.js";
import "@ucl/shared-component-foundations";
import "./useClient.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import "./isClient-2f5bedbd.js";
import "./useEventListener.js";
import "./getTarget-19e0f923.js";
import "./web.set-timeout-72b6430f.js";
import "./environment-ddee5959.js";
import "./array-slice-79f93c56.js";
import "./validate-arguments-length-eb516e5b.js";
import "./combineRefs-c9ad2c39.js";
import "./useOnClickOutside.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./isApiSupported-66660265.js";
import "./useIsMounted.js";
import "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import "react/jsx-runtime";
import "./es.parse-int-d7709701.js";
import "./string-trim-14e37ad3.js";
import "./getMetrics-953aa4f8.js";
import "./badge.js";
import "./es.date.to-string-6ed49878.js";
import "./es.regexp.to-string-e800d529.js";
import "./es.string.small-23219181.js";
import "./string-html-forced-a746405b.js";
import "styled-components";
import "./index-5d0f31c6.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./an-instance-6efcfd6c.js";
import "./inherit-if-required-f068457b.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./set-species-5ede2ed0.js";
import "@ucl/shared-icons";
import "./popupTip-06ee114c.js";
import "react-dom";
import "./usePopoverIndex.js";
import "./aria.js";
import "./useWindowSize.js";
import "./button.js";
import "./divider.js";
import "./closeButton.js";
import "./iconButton.js";
import "./getElementPosition-8d0dbc61.js";
import "./es.string.starts-with-a6645e0a.js";
import "./es.string.link-fd2676c6.js";
import "./es.array.join-c1bca812.js";
import "./es.parse-float-020a2ae0.js";
import "./es.regexp.constructor-6da4b85c.js";
import "./uniqueId.js";
import "./es.global-this-a7f40ce1.js";
var Ko = /* @__PURE__ */ function(o) {
  return o.ICON = "icon", o.NUMBER = "number", o.DOT = "dot", o;
}({});
export {
  Qo as MapMarker,
  Ko as MarkerVariants
};
